<section>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 mapa-nav">
                <div class="content-header animate__animated animate__fadeInLeft">{{navegacion.titulo}}</div>
              </div>
              <div class="col-md-6" *ngIf="navegacion.irAtras">
                <button type="button" class="btn btn-info mr-1 mb-1 float-right" (click)="atras()"><i class="ft-corner-up-left mr-1"></i>Atrás</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
